const prod = {
  url: process.env.REACT_APP_BASE_URL,
};
// do not touch
const dev = {
  url: false  ? "http://localhost:6178" : process.env.REACT_APP_BASE_URL,
};



export const { url } = process.env.NODE_ENV === "development" ? dev : prod;

export const getInterfaceDetails = url + "/api/Interface/getInterfaceDetails";
export const getDropdowns = `${url}/api/Commondropdowns/getDropDownValueDetails`;
export const getTabsData = url + "/api/Tabs/getTabs";
export const getAttributeValueDetails =
  url + "/api/AttributesValues/GetAttributeValueDetails";
export const changePassword = url + "/api/Login/ChangePassword";

export const postAttributeValueDetails =
  url + "/api/Attribute/PostAttributeDetails";

export const getDashboardGridData = url + "/api/Dashboard/GetDashboardGridData";

//Parameter
export const getDropdownsData = `${url}/api/Parameter/getFilterDropdownsforParameter`;
export const getParameterDashboardData = `${url}/api/Parameter/getParameterDashboardData`;
export const getParameterExportToExcel = `${url}/api/Parameter/getParameterExportToExcel`;

export const insertUpdateParametertDetails = `${url}/api/Parameter/InsertupdateParameterData`;
export const getParameterDetailsById = `${url}/api/Parameter/getParameterDetailsById`;

//Project
export const getGenericDropdownsData = `${url}/api/Project/getGenericDropdowns`;
export const getProjectDashboardData = `${url}/api/Project/getProjectDashboardData`;
export const getProjectGridDataExport = `${url}/api/Project/getProjectExportToExcel`;
export const InsertUpdateProjectData = `${url}/api/Project/InsertupdateProjectData`;
export const getProjectDetailsById = `${url}/api/Project/getProjectDetailsById`;
export const getProjectUsers = `${url}/api/Project/getUserListByRole`;
export const deleteProjectUserMapping = `${url}/api/Project/deleteProjectUserMapping`;
export const insertProjectUserMapping = `${url}/api/Project/insertProjectUserMapping`;
export const getProjectUserMapedById = `${url}/api/Project/getProjectUserMappingDetailsById`;
export const getADUsers = `${url}/api/Project/GetAzureADUser`;
export const InsertUserInMaster = `${url}/api/Project/insertIntoUserMaster`;
export const CheckUserExist = `${url}/api/Project/CheckIfUserExistsInMaster`;
export const CheckUserRoleExist = `${url}/api/Project/CheckIfUserRoleExistsInMaster`;
export const InsertUserRoleInMaster = `${url}/api/Project/insertIntoUserRoleMaster`;
export const GetProjectJobDetailsDataById = `${url}/api/Project/GetProjectJobDetailsDataById`;

export const getDashboardGridDataExport =
  url + "/api/Dashboard/DashboardExportToExcel";

export const getAllGenericMasterData =
  url + "/api/Generic/GetAllGenericMasterData";
export const getAllStatusMasterData =
  url + "/api/Status/GetAllStatusMasterData";

export const getRequestDetailsById = url + "/api/Request/GetRequestDetailsById";

export const InsertUpdateRequestDetails =
  url + "/api/Request/InsertUpdateRequestDetails";

export const getViewDetailsData = url + "/api/ViewDetails/GetViewDetails";

export const getControlsData = url + "/api/Controls/GetControls";

export const getTenantFramework =
  url + "/api/TenantFramework/GetTenantFramework";

export const getInvoiceGridData = url + "/api/Invoice/getInvoiceData";

export const getTenantDetails = url + "/api/Common/GetTenantDetails";

export const uploadInvoiceDocument = url + "/api/Invoice/uploadInvoiceDocument";

export const tenant1Localhost = "https://localhost:5003";

export const tenant2Localhost = "https://localhost:5002";

export const getFilterData = url + "/api/FilterData/GetFilterData";

export const getSidebarData = url + "/api/Module/GetModuleData";

export const getUserDetails = url + "/api/User/getUserData";

export const invoiceSubmit = url + "/api/Invoice/InsertUpdateInvoiceData";

export const getInvoiceDataById = url + "/api/Invoice/getInvoiceDataById";

export const getInvoiceDocTypes = url + "/api/Invoice/getInvoiceDocTypes";

export const getTabDetails = url + "/api/Tabs/GetTabs";


export const getRolesDetails = url + "/api/Roles/GetRoles";

export const getEntityFilter = url + "/api/Roles/GetEntity";

export const getVendorFilter = url + "/api/Roles/GetVendor";

export const getQueryGridData = url + "/api/Query/GetQueryGridData";

export const getUserList = url + "/api/User/getUserList";

export const getInvoiceHistoryById = url + "/api/Invoice/GetInvoiceHistoryById";

export const getQueryDataById = url + "/api/Query/GetQueryDataById";

export const getClosedQueryById = url + "/api/Query/GetClosedQueryById";

export const insertUpdateQuery = url + "/api/Query/InsertUpdateQuery";

export const getQueryDocumentById = url + "/api/Query/GetQueryDocumentById";

export const getDataFromInvoiceExtraction =
  url + "/api/Invoice/ExtractInvoiceData";
export const trainInvoice = url + "/api/Invoice/TrainInvoiceData";
export const getPoGridData = url + "/api/PurchaseOrder/getPurchaseOrderData";

export const getPoFormData = url + "/api/PurchaseOrder/getPoFormData";

export const loginUrl = url + "/api/Login/Authenticate";
export const logoutUrl = url + "/api/Login/Logout";

export const GetInvoiceTypeDashboardData =
  url + "/api/InvoiceType/GetDashboardData";

export const GetInvoiceTypeOptions =
  url + "/api/InvoiceType/GetInvoiceTypeOptions";

export const InvoiceTypExportToExcel =
  url + "/api/InvoiceType/GetExportToExcel";

export const GetAdminsOptions = url + "/api/InvoiceType/GetAdminsOptions";

export const InsertUpdateGenericOUMapping =
  url + "/api/InvoiceType/InsertUpdateGenericMasterWithOUMapping";

export const GetOUMappingDetailsById =
  url + "/api/InvoiceType/GetOUMappingDetailsById";

export const GetConfigValueByConfigKey =
  url + "/api/InvoiceType/GetConfigValueByConfigKey";

// structure type

export const GetStructureTypeGridData = url + "/api/Structure/GetGridData";

export const GetStructureTypeGridDataExport =
  url + "/api/Structure/GetGridDataExport";

export const InsertUpdateStructureType =
  url + "/api/Structure/InsertUpdateStructureData";

export const InsertUpdateStructureDetailsData =
  url + "/api/Structure/InsertUpdateStructureDetailsData";

export const GetStructureDataById = url + "/api/Structure/GetStructureDataById";

export const GetStructureDetailsDataById =
  url + "/api/Structure/GetStructureDetailsDataById";

// structure type

export const CommonDropdownData = url + "/api/CommonDropdown/GetDropdownData";
export const GetLocationData = url + "/api/CommonDropdown/GetLocationdata";
export const GetMultipleDropdownData =
  url + "/api/CommonDropdown/GetMultipleDropdownData";
export const GetFinancialYearDropdown = `${url}/api/CommonDropdown/GetFinancialYearDropdown`;
//user Master

export const getRoleDropdowndata = `${url}/api/User/getRoleDropdownData`;
export const InsertupdateUserData = `${url}/api/User/InsertupdateUserData`;
export const getUserDashboardData = `${url}/api/User/getUserDashboardData`;
export const getUserExportToExcel = `${url}/api/User/getUserExportToExcel`;
export const getUserDetailsById = `${url}/api/User/getUserDetailsById`;

//get user

export const GetUserDropdown = url + "/api/CommonDropdown/GetUserDropdown";

//insert user role
export const insertUserrole = `${url}/api/UserRoleMapping/InsertUserRoleMapping`;

//get userrolemapping

export const getUserRoleMappingData = `${url}/api/UserRoleMapping/GetUserRoleMappingDashboardData`;
export const getUserRoleMappingDataById = `${url}/api/UserRoleMapping/GetUsesrRoleMappingDataById`;
export const getUserRoleMappingExporttoExcel = `${url}/api/UserRoleMapping/getUserRoleMappingExportToExcel`;

//authentication
export const login = `${url}/api/Login/CheckUserCredentials1`;
export const ForgotPassword = `${url}/api/Login/ForgotPassword`;
export const CheckForgotPasswordKey = `${url}/api/Login/CheckForgotPasswordKey`;
export const UpdatePassword = `${url}/api/Login/UpdatePassword`;
export const WhoAmI = `${url}/api/SSO/WhoAmI`;
export const ValidateUser = `${url}/api/SSO/ValidateUser`;

//registrationRequest
export const getRegistrationRequestData = `${url}/api/RegistrationRequest/GetRegistrationRequestData`;

export const downloadRegistrationRequestData = `${url}/api/RegistrationRequest/DownloadRegistrationRequestData`;

//get member status details
export const getMemberRegistrationStatusByMemberId = `${url}/api/MemberRegistration/GetMemberRegistrationStatusByMemberId`;

//member registration
export const insertMemberpersonaldetaiks = `${url}/api/MemberRegistration/PostPersonalDetails`;
export const insertUpdateWitnessdetails = `${url}/api/MemberRegistration/PostWitnessDetails`;
export const insertUpdateEmployeedetails = `${url}/api/MemberRegistration/PostEmploymentDetails`;
export const insertUpdateNomineedetails = `${url}/api/MemberRegistration/PostNomineeDetails`;
export const insertUpdateNomineeIsAgreedTC = `${url}/api/MemberRegistration/PostMemberNomineeIsAgreedTC`;
export const getWitnessDeatilsByMemberId = `${url}/api/MemberRegistration/GetWitnessDetailsByMemberId`;
export const getNomineeDetailsByMemberId = `${url}/api/MemberRegistration/GetAllNomineeList`;
export const getNomineeDetailsById = `${url}/api/MemberRegistration/GetMemberNomineeById`;
export const getEmploymentDetailsByMemberId = `${url}/api/MemberRegistration/GetEmploymentDetailsByMemberId`;
export const getPersonalDetailsByMemberId = `${url}/api/MemberRegistration/GetPersonalDetailsById`;
export const getPersonalDetailsById = `${url}/api/MemberRegistration/GetPersonalDetailsById`;
export const getCoreUsersEmploymentDetailsByTokenNo = `${url}/api/MemberRegistration/GetCoreUsersEmploymentDetailsByTokenNo`;

//kyc details
export const insertUpdateKyc = `${url}/api/MemberRegistration/PostKycDetails`;
export const documentDetails = `${url}/api/MemberRegistration/PostDocumentDetails`;
export const getKycId = `${url}/api/MemberRegistration/GetKycDetailsByMemberId`;

//payment details
export const insertUpdateInitalDeposit = `${url}/api/MemberRegistration/PostInitialPayment`;
export const insertUpdatePaymentDetails = `${url}/api/MemberRegistration/PostPaymentDetails`;
export const getInitalDeposit = `${url}/api/MemberRegistration/PostPaymentDetails`;
export const getPostPaymentDetails = `${url}/api/MemberRegistration/GetPaymentDetailsByMemberId`;
//config service
export const configValue = `${url}/api/MemberRegistration/GetCongfigValue`;
export const getConfigValues = `${url}/api/Config/GetConfigValues`;
export const createpassword = `${url}/api/Login/UpdatePasswordByMemberId`;
//registration Approval
export const insertIntoMemberEnrollmentHistory = `${url}/api/RegistrationApproval/InsertIntoMemberEnrollmentHistory`;

export const getCurrentUserRolesDropdown = `${url}/api/UserRoleMapping/getCurrentUserRolesDropdown`;
//payment Verification
export const getPaymentVerificationData = `${url}/api/PaymentVerification/GetPaymentVerificationData`;

//otp member
export const checkContactExist = `${url}/api/Login/CheckContactExisits`;
export const checkotpexisit = `${url}/api/Login/CheckOtpExisits`;

//OAuth
export const fetchToken = `${url}/api/OAuth/token`;

//Azure blob
export const getDocumentToken = `${url}/api/AzureBlob/GetDocumentToken`;

// Sector
export const getSectorData = `${url}/api/Master/GetSectorData`;
export const insertUpdateSectorData = `${url}/api/Master/InsertUpdateSectorData`;
export const getSectorDataById = `${url}/api/Master/GetSectorDataById`;
export const getSectorExporttoExcel = `${url}/api/Master/getSectorExportToExcel`;
export const uploadBulkSectorDetails = `${url}/api/Master/UploadBulkSectorDetails`;

// Location
export const getLocationDashboardData = `${url}/api/Master/GetLocationDashboardData`;
export const insertUpdateLocationData = `${url}/api/Master/InsertLocationData`;
export const getUnitCodeDropdown = `${url}/api/Master/GetUnitCodeDropdown`;
export const getLocationDataById = `${url}/api/Master/GetLocationDataById`;
export const getLocationExportToExcel = `${url}/api/Master/getLocationExportToExcel`;
export const uploadBulkLocationDetails = `${url}/api/Master/UploadBulkLocationDetails`;

// UNIT CODE
export const getUnitCodeDashboardData = `${url}/api/Master/GetUnitCodeDashboardData`;
export const insertUpdateUnitCodeData = `${url}/api/Master/InsertUpdateUnitCodeData`;
export const getUnitCodeDataById = `${url}/api/Master/GetUnitCodeDataById`;
export const getUnitCodeExportToExcel = `${url}/api/Master/getUnitCodeExportToExcel`;
export const uploadBulkUnitCodeDetails = `${url}/api/Master/UploadBulkUnitCodeDetails`;
export const getUnitCodeDropdownById =
  url + "/api/Master/GetUnitCodeDropdownById";

// Company
export const getCompanyDashboardData = `${url}/api/Master/GetCompanyDashboardData`;
export const getCompanyExportToExcel = `${url}/api/Master/getCompanyExportToExcel`;
export const uploadBulkCompanyDetails = `${url}/api/Master/UploadBulkCompanyDetails`;
export const getCompanyDataById = `${url}/api/Master/GetCompanyDataById`;
export const insertUpdateCompanyData = `${url}/api/Master/InsertUpdateCompanyData`;

//Loan Modulesy
export const getShortTermLoan = `${url}/api/LoanModule/GetShortTermLoan`;
export const getLongTermLoan = `${url}/api/LoanModule/GetLongTermLoan`;
export const checkShortTermLoanEligibility = `${url}/api/LoanModule/CheckShortTermLoanEligibility`;
export const checkLongTermLoanEligibility = `${url}/api/LoanModule/CheckLongTermLoanEligibility`;
export const getLoanTermDetails = `${url}/api/LoanModule/GetLoanTermDetails`;
export const getEligibleLoanAmount = `${url}/api/LoanModule/GetEligibleLoanAmount`;
export const loanModuleGetPersonalDetailsByMemberId = `${url}/api/LoanModule/GetPersonalDetailsByMemberId`;
export const getMemberSuretyDetailById = `${url}/api/LoanModule/GetMemberSuretyDetailById`;
export const postPersonalCurrentSalarySlipAndChequeBook = `${url}/api/LoanModule/PostPersonalCurrentSalarySlipAndChequeBook`;
export const postLoanDetails = `${url}/api/LoanModule/PostLoanDetails`;
export const postLongTermLoanDetails = `${url}/api/LoanModule/PostLongTermLoanDetails`;
export const postSuretyDetails = `${url}/api/LoanModule/PostSuretyDetails`;
export const postLoanRequestStatusEMI = `${url}/api/LoanModule/PostLoanRequestStatusEMI`;
export const postLoanRequestStatus = `${url}/api/LoanModule/PostLoanRequestStatus`;
export const suretyDetailsApproval = `${url}/api/LoanModule/SuretyDetailsApproval`;
export const getLoanRequestData = `${url}/api/LoanModule/GetLoanRequestData`;
export const getLoanRequestDataForRepayment = `${url}/api/LoanModule/GetLoanRequestDataForRepayment`;
export const getLoanRequestDataById = `${url}/api/LoanModule/GetLoanRequestDataById`;
export const GetLoanRequestDataExportToExcel = `${url}/api/LoanModule/GetLoanRequestDataExportToExcel`;
export const GetLoanRepaymentExportToExcel = `${url}/api/LoanModule/GetLoanRepaymentExportToExcel`;
export const LoanExportToCSV = `${url}/api/LoanModule/LoanExportToCSV`;
export const SettlementExportToCSV = `${url}/api/Settlement/CreateSettlementCSV`;
export const DownloadLoanAgreementData = `${url}/api/LoanModule/DownloadLoanAgreementData`;
export const DownloadLoanAgreementDataLetterHeadData = `${url}/api/LoanModule/DownloadLoanAgreementLetterHeadData`;
export const getShortTermAmountDropdown = `${url}/api/LoanModule/GetShortTermAmountDropdown`;
export const getInstallmentDuration = `${url}/api/LoanModule/GetInstallmentDuration`;
export const longTermCalculation = `${url}/api/LoanModule/GetLongTermLoanAmount`;
export const additionLongTermCalculation = `${url}/api/LoanModule/AdditionLongTermCalculation`;
export const updateLoanRequestStateId = `${url}/api/LoanModule/UpdateLoanRequestStateId`;
export const updateMemberAgreement = `${url}/api/LoanModule/UpdateMemberAgreement`;
export const updateLoanCommitteeApproval = `${url}/api/LoanModule/UpdateLoanCommitteeApproval`;
export const GetLoanDetailsById = `${url}/api/LoanModule/GetLoanDetailsById`;
export const ReplaceSurety = `${url}/api/LoanModule/ReplaceSurety`;
export const RemoveSurety = `${url}/api/LoanModule/RemoveSurety`;
export const getShortTermLoanCalcByLoanId = `${url}/api/LoanModule/GetShortTermLoanCalcByLoanId`;
export const getLongTermLoanCalcByLoanId = `${url}/api/LoanModule/GetLongTermLoanCalcByLoanId`;
export const GetAllSuretiesByMemberId = `${url}/api/LoanModule/GetAllSuretiesByMemberId`;

// Company
export const getLoanInterestDataById = `${url}/api/Master/GetLoanInterestDataById`;
export const insertUpdateLoanInterestData = `${url}/api/Master/InsertUpdateLoanInterestData`;
export const getLoanInterestDashboardData = `${url}/api/Master/GetLoanInterestDashboardData`;
export const getLoanInterestExportToExcel = `${url}/api/Master/getLoanInterestExportToExcel`;
export const getLoanDetailsForApproval = `${url}/api/LoanModule/GetLoanDetailsForApproval`;
export const getSuretyDetailsByMemberId = `${url}/api/LoanModule/GetSuretyDetailsByMemberId`;
export const getSuretyDetailsForApproval = `${url}/api/LoanModule/GetSuretyDetailsForApproval`;

export const getAllLoanTypeList = `${url}/api/LoanModule/GetAllLoanTypeList`;

export const sectorSampleFileExportToExcel = `${url}/api/Master/sectorSampleFileExportToExcel`;
export const companySampleFileExportToExcel = `${url}/api/Master/companySampleFileExportToExcel`;
export const locationSampleFileExportToExcel = `${url}/api/Master/locationSampleFileExportToExcel`;
export const unitcodeSampleFileExportToExcel = `${url}/api/Master/unitcodeSampleFileExportToExcel`;

export const testMethod = `${url}/api/Config/TestMethod`;

//Statement Request
export const GetStatmentReqExportToExcel = `${url}/api/Yojna/GetStatmentReqExportToExcel`;

//MemberDashboard
export const GetMemberDashboardDetails = `${url}/api/MemberDashboard/GetMemberDashboardDetails`;
export const insertLoanPaymentDetailsData = `${url}/api/MemberDashboard/InsertLoanPaymentDetailsData`;
export const GetYearDropDown = `${url}/api/MemberDashboard/GetYearDropDown`;
export const GetSubMemberDetails = `${url}/api/MemberDashboard/GetSubMemberDetails`;
export const GetsubscriptionDashboardDetails = `${url}/api/MemberDashboard/GetsubscriptionDashboardDetails`;
export const CheckLoanIsOnMember = `${url}/api/MemberDashboard/CheckLoanIsOnMember`;
export const UpdateInitialAmount = `${url}/api/MemberDashboard/UpdateInitialAmount`;
// SanjeevaniForm
export const GetYojnaDepositDashboardDataByMemberId = `${url}/api/Yojna/GetYojnaDepositDashboardDataByMemberId`;
export const InsertUpdateYojna = `${url}/api/Yojna/InsertUpdateYojna`;
export const documentDetails2 = `${url}/api/Yojna/PostDocumentDetails`;
export const GetSJNYAdminDepostRequestDashboard = `${url}/api/Yojna/GetSJNYAdminDepostRequestDashboard`;
export const getSNJYDepositRequestExportToExcel = `${url}/api/Yojna/GetSNJYDepositRequestExportToExcel`;
export const UpdateStatusByAdmin = `${url}/api/Yojna/UpdateStatusByAdmin`;
export const GetUserDetailsByRequestId = `${url}/api/Yojna/GetUserDetailsByRequestId`;
export const GetYojnaStatmentDashboardDetails = `${url}/api/Yojna/GetYojnaStatmentDashboardDetails`;
export const GetYojnaStatmentExportToExcel = `${url}/api/Yojna/GetYojnaStatmentExportToExcel`;
export const GetYojnaWithrawRequestDashboard = `${url}/api/Yojna/GetYojnaWithrawRequestDashboard`;
export const UpdateWithdrawRequestFromDepositToWithdraw = `${url}/api/Yojna/UpdateWithdrawRequestFromDepositToWithdraw`;
export const UpdateWithdrawStatusByAdmin = `${url}/api/Yojna/UpdateWithdrawStatusByAdmin`;
export const GetSNJYWithdrawRequestExportToExcel = `${url}/api/Yojna/GetSNJYWithdrawRequestExportToExcel`;
export const InsertRenewalYojna = `${url}/api/Yojna/InsertRenewalYojna`;
export const ClosedSanjeevaniYojna_FD = `${url}/api/Yojna/ClosedSanjeevaniYojnaRecordForRenewal`;
export const DownloadsuvidhaReceiptData = `${url}/api/Yojna/DownloadsuvidhaReceiptData`;
export const DownloadsanjeevaniReceiptData = `${url}/api/Yojna/DownloadsanjeevaniReceiptData`;
export const GetSUVYDepositRequestExportToExcel = `${url}/api/Yojna/GetSUVYDepositRequestExportToExcel`;
export const GetSUVYWithdrawRequestExportToExcel = `${url}/api/Yojna/GetSUVYWithdrawRequestExportToExcel`;
export const GetSuvidhaYojnaStatmentExportToExcel = `${url}/api/Yojna/GetSuvidhaYojnaStatmentExportToExcel`;
export const DownloadSuvidhaApplicationForm = `${url}/api/Yojna/DownloadSuvidhaApplicationForm`;
export const DownloadSanjeevaniApplicationForm = `${url}/api/Yojna/DownloadSanjeevaniApplicationForm`;
export const GetsubscriptionExportToExcel = `${url}/api/MemberDashboard/GetsubscriptionExportToExcel`;
// Loan Repayment
export const getRePaymentHistory = `${url}/api/LoanRepayment/GetRePaymentHistory`;
export const CheckLoanRepaymentCriteria = `${url}/api/LoanRepayment/CheckLoanRepaymentCriteria`;
export const GetLoanRepaymentCalculatedAmounts = `${url}/api/LoanRepayment/GetLoanRepaymentCalculatedAmounts`;
export const InsertLoanRepaymentDetails = `${url}/api/LoanRepayment/InsertLoanRepaymentDetails`;
export const GetLoanRepaymentDetailsById = `${url}/api/LoanRepayment/GetLoanRepaymentDetailsById`;
export const PostLoanRepaymentApproval = `${url}/api/LoanRepayment/PostLoanRepaymentApproval`;
export const InsertLoanRepaymentPaymentDetails = `${url}/api/LoanRepayment/InsertLoanRepaymentPaymentDetails`;
export const GetLoanRepaymentPaymentDetails = `${url}/api/LoanRepayment/GetLoanRepaymentPaymentDetails`;

export const SettlementRequest = `${url}/api/SubscriptionSettlementRequest/SettlementRequest`; //added by mahesh
export const SubmitSettlement = `${url}/api/SubscriptionSettlementRequest/SubmitSettlement`;
export const UpdateApprovalSettlementRequest = `${url}/api/SubscriptionSettlementRequest/UpdateApprovalSettlementRequest`;
export const IsSettilementRequestExist = `${url}/api/SubscriptionSettlementRequest/IsSettilementRequestExist`;

//START Settlement Req tab
export const GetSettlementrequestDetails = `${url}/api/Settlement/GetSettlementrequestDetails`;
export const GetExportToExcelOfAllrequestOfSettlement = `${url}/api/Settlement/GetExportToExcelOfAllrequestOfSettlement`;
export const GetExportToExcelOfPendingrequestOfSettlement = `${url}/api/Settlement/GetExportToExcelOfPendingrequestOfSettlement`;

export const SettlementDetailsById = `${url}/api/Settlement/SettlementDetailsById`;
export const FinalSettlementDataBySetId = `${url}/api/Settlement/GetFinalSettlementDataBySetId`;
export const DownloadFinalSettlementData = `${url}/api/Settlement/DownloadFinalSettlementData`;
export const SendEmailFinalSettlementData = `${url}/api/Settlement/SendEmailFinalSettlementData`;
//END Settlement Req tab

export const DownloadSettlementApplicationForm = `${url}/api/Settlement/DownloadSettlementApplicationForm`;
export const DownloadSettlementApplicationFormAfterApprovel = `${url}/api/Settlement/DownloadSettlementApplicationFormAfterApprovel`;
export const GetReasonofRequestDropdownData = `${url}/api/SubscriptionSettlementRequest/GetReasonofRequestDropdownData`;
export const GetSettlementRequestDetailsByRequestID = `${url}/api/SubscriptionSettlementRequest/GetSettlementRequestDetailsByRequestID`;

export const GetLoanRequestPieChartDetails = `${url}/api/Settlement/GetLoanRequestPieChartDetails`;
export const GetSettlementPieChartDetails = `${url}/api/Settlement/GetSettlementPieChartDetails`;
export const GetBarGraphDetailsForSettlement = `${url}/api/Settlement/GetBarGraphDetailsForSettlement`;

//Demand and Recovery
export const GetDemandRecoveryDashboard = `${url}/api/DemandRecovery/GetDemandRecoveryDashboard`;
export const GetDemandRecoveryExportToExcel = `${url}/api/DemandRecovery/GetDemandRecoveryExportToExcel`;
export const GetDemandRecoveryForm = `${url}/api/DemandRecovery/GetDemandRecoveryForm`;

export const InsertLongLoanEmailSMS = `${url}/api/DemandRecovery/InsertLongLoanEmailSMS`;
export const InsertShortLoanEmailSMS = `${url}/api/DemandRecovery/InsertShortLoanEmailSMS`;
export const GetYearlyActivitiesAndCertificateDetails = `${url}/api/YearlyActivities/GetYearlyActivitiesAndCertificateDetails`;
export const DownloadYearlyActivitiesData = `${url}/api/YearlyActivities/DownloadYearDividendForm`;
export const DownloadShareCertificateData = `${url}/api/YearlyActivities/DownloadShareCertificateData`;
export const CreateEmailForYearlyDividend = `${url}/api/YearlyActivities/CreateEmailForYearlyDividend`;
export const CreateEmailForShareCertificate = `${url}/api/YearlyActivities/CreateEmailForShareCertificate`;
export const GetMemberReportsExportToExcel = `${url}/api/MemberReports/GetMemberReportsExportToExcel`;

// Operation Year
export const GetNewMemberDetailsMonthWiseDashboard = `${url}/api/MonthlyReport/GetNewMemberDetailsMonthWiseDashboard`;
export const SampleFileExportToExcelUrlMemberTableReco = `${url}/api/SampleFileExportToExcelUrlMemberTableReco`;
export const GetSettledMemberRegisterReport = `${url}/api/MonthlyReport/GetSettledMemberRegisterReport`;
export const GetNewMemberDetailsYearWiseDashboard = `${url}/api/YearlyReport/GetNewMemberDetailsYearWiseDashboard`;
export const DownloadPdfDocData = `${url}/api/YearlyReport/DownloadReportDocumentPdf`;
export const InsertYearlyWarrentReport = `${url}/api/YearlyReport/InsertYearlyWarrentReport`;

export const GetNewMemberRegisterInformationReport = `${url}/api/MonthlyReport/GetNewMemberRegisterInformationReport`;
export const GetSuretyRegisterReportExportToExcel = `${url}/api/SuretyRegisterReport/GetSuretyRegisterReportExportToExcel`;
export const GetYearlyDividendCalculationReportExportToExc = `${url}/api/YearlyDividendCalculationReport/GetYearlyDividendCalculationReportExportToExc`;
export const GetLoanPaidInExcessVSEligibilityReport = `${url}/api/MonthlyReport/GetLoanPaidInExcessVSEligibilityReport`;
export const GetLoanRegisterReport = `${url}/api/MonthlyReport/GetLoanRegisterReport`;
export const GetHDFCtoHDFCReport = `${url}/api/YearlyReport/GetHDFCtoHDFCReport`;
export const DownloadMemberRecoveryReport = `${url}/api/MonthlyReport/DownloadMemberRecoveryReport`;
export const GetYearlyDividendCalculationReportExportToExcel = `${url}/api/YearlyDividendCalculationReport/GetYearlyDividendCalculationReportExportToExcel`;
export const DividentNEFTToCSV = `${url}/api/YearlyReport/DividentNEFTToCSV`;
export const DownloadMemberTableRecord = `${url}/api/MonthlyReport/DownloadMemberTableRecord`;
export const UploadMemberUpdatedFile = `${url}/api/MonthlyReport/UploadMemberUpdatedFile`;
export const GetLoanShortRecoveryReport = `${url}/api/MonthlyReport/GetLoanShortRecoveryReport`;
export const GetShareRegisterReport = `${url}/api/YearlyReport/GetShareRegisterReport`;
// export const = ``

//added by sonu

export const GetLoanModuleHistory=`${url}/api/LoanModule/GetLoanHistory`;
export const DeleteLoanRequestByLoanId=`${url}/api/LoanModule/DeleteLoanRequestByLoanId`;

// By Arbaz 
//MemberDashboard
export const GetMemberDashboardDetailsByYojnaController = `${url}/api/Yojna/GetMemberDashboardDetails`;

